import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import { useIsMobile } from '../hooks/useIsMobile';

export default function FeedbackButton() {
  const [showModal, setShowModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  const baseButtonStyles = {
    position: 'fixed',
    bottom: isMobile ? '80px' : '24px',
    right: '24px',
    zIndex: 100,
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: 'var(--nsi-brand)',
    border: 'none',
    color: 'white',
    fontSize: '24px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(var(--nsi-brand-rgb), 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'width 0.25s ease, border-radius 0.25s ease, padding 0.25s ease, transform 0.15s ease'
  };

  const hoveredButtonStyles = {
    width: '172px',
    borderRadius: '9999px',
    padding: '0 16px',
    justifyContent: 'flex-start',
    transform: 'scale(1.03)'
  };

  const labelStyles = {
    fontSize: '14px',
    fontWeight: 600,
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 0.15s ease',
    pointerEvents: 'none'
  };

  const buttonStyles = {
    ...baseButtonStyles,
    ...(isMobile ? {} : (isHovered ? hoveredButtonStyles : {}))
  };

  return (
    <>
      <button
        style={buttonStyles}
        onClick={() => setShowModal(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Leave Feedback"
        aria-label="Leave Feedback"
      >
        <i className="bi bi-chat-dots"></i>
        {!isMobile && isHovered && (
          <span style={labelStyles}>Leave feedback</span>
        )}
      </button>
      
      <FeedbackModal
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}